import React, { Component } from 'react'
import { compose, withProps } from 'recompose'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import { t } from 'i18next'
import mapStyles from './mapStyles.json'
import './index.css'

const MyMapComponent = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAqvJPxDPwFzPkOKnh_nlCGmfztafUX3KY&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div className="map mapLoading" style={{ width: `100%`, height: `100%` }} />,
    containerElement: <div className="map mapContainer" style={{ width: `100%`, height: `100%` }} />,
    mapElement: <div className="map mapElement" style={{ width: `100%`, height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(props =>
  <GoogleMap
    defaultZoom={18}
    defaultCenter={{ lat: 50.7733938, lng: 6.0156966 }}
    defaultOptions={{
      styles: mapStyles,
      streetViewControl: false,
      scaleControl: false,
      mapTypeControl: false,
      panControl: false,
      zoomControl: false,
      rotateControl: false,
      fullscreenControl: false
    }}>
    {props.isMarkerShown && <Marker position={{ lat: 50.7733938, lng: 6.0156966 }} />}
  </GoogleMap>
)

export default class Contact extends Component {
  render() {
    return (
      <div className="Contact">
        <MyMapComponent isMarkerShown />
        <div className="wrap">
          <div>
            <h2>{t('contact.request_estimate')}</h2>
            <p>+31 6 54 35 59 98</p>
            <p>info@bizonprefab.nl</p>
            <div><a href="tel:+31654355998">{t('contact.call')}</a></div>
            <div><a href="mailto:info@bizonprefab.nl">{t('contact.email')}</a></div>
          </div>
          <div>
            <h2>{t('contact.visit_showroom')}</h2>
            <p>Maastrichterlaan 160b<br />
            6291 EW, Vaals<br />
            Nederland</p>
            <div><a href="https://goo.gl/maps/TjBgq53j7wF2" target="_blank" rel="noopener noreferrer">{t('contact.fetch_route')}</a></div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Contact/index.js